export const statusList = [
    { value: 'ABERTO', label: 'Pendente suporte' },
    { value: 'CLIENTE', label: 'Pendente cliente' },
    { value: 'ENCERRADO', label: 'Encerrado (Sem solução)' },
    {value: 'BLOQUEIO', label: 'Pendente comercial'},
    {value: 'SOLUCIONADO', label: 'Encerrado (solucionado)'},
]